// Filter Courses Listing
(function () {
    document.addEventListener('DOMContentLoaded', function () {
        const filterForm = document.querySelector('.courses-filter');
        if (!filterForm) {
            return;
        }

        const INACTIVE_CLASS = 'inactive';
        const POSTS_SELECTOR = '.wp-block-post';

        const posts = Array.from(
            document.querySelectorAll(POSTS_SELECTOR)
        );

        if (!posts.length) {
            return;
        }

        function getActiveTokens() {
            const checked = filterForm.querySelectorAll(
                'input[type="checkbox"]:checked'
            );

            return Array.from(checked)
                .map((input) => input.value || input.name)
                .filter(Boolean);
        }

        function updatePostsState() {
            const activeTokens = getActiveTokens();

            if (activeTokens.length === 0) {
                posts.forEach((post) => {
                    post.classList.remove(INACTIVE_CLASS);
                });
                return;
            }

            posts.forEach((post) => {
                const matchesAny = activeTokens.some((token) =>
                    post.classList.contains(token)
                );

                if (matchesAny) {
                    post.classList.remove(INACTIVE_CLASS);
                } else {
                    post.classList.add(INACTIVE_CLASS);
                }
            });
        }

        filterForm.addEventListener('change', function (event) {
            const target = event.target;
            if (
                !(target instanceof HTMLInputElement) ||
                target.type !== 'checkbox'
            ) {
                return;
            }

            updatePostsState();
        });

        updatePostsState();
    });
})();

// Insert POST-ID to mark-complete BTN
(function () {
    const BUTTON_SELECTOR = '#mark-complete, .btn-mark-complete';

    function getCurrentPostIdFromBody() {
        const body = document.body;
        if (!body) {
            return null;
        }

        const idClass = Array.from(body.classList).find((cls) =>
            cls.startsWith('postid-')
        );

        if (!idClass) {
            return null;
        }

        const id = Number.parseInt(idClass.replace('postid-', ''), 10);

        return Number.isFinite(id) && id > 0 ? id : null;
    }

    function attachPostIdToButtons(root = document) {
        const postId = getCurrentPostIdFromBody();
        if (!postId) {
            return;
        }

        const buttons = root.querySelectorAll(BUTTON_SELECTOR);
        if (!buttons.length) {
            return;
        }

        buttons.forEach((btn) => {
            if (!btn.dataset.postId) {
                btn.dataset.postId = String(postId);
            }
        });
    }

    document.addEventListener('DOMContentLoaded', () => {
        attachPostIdToButtons();
    });
})();

// Set cookie when mark-complete BTN is clicked
(function () {
    document.addEventListener('DOMContentLoaded', function () {
        const COOKIE_NAME = 'completed-status';
        const BUTTON_SELECTOR = '#mark-complete';
        const COMPLETED_CLASS = 'is-completed';

        function getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) {
                return parts.pop().split(';').shift();
            }
            return null;
        }

        function setCookie(name, value, days = 365) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

            document.cookie = [
                `${name}=${value}`,
                `expires=${date.toUTCString()}`,
                'path=/',
                'SameSite=Lax'
            ].join('; ');
        }

        function getCompletedIds() {
            const raw = getCookie(COOKIE_NAME);
            if (!raw) {
                return [];
            }

            try {
                const decoded = decodeURIComponent(raw);
                const parsed = JSON.parse(decoded);
                if (Array.isArray(parsed)) {
                    return parsed
                        .map((id) => parseInt(id, 10))
                        .filter((id) => Number.isFinite(id) && id > 0);
                }
            } catch (e) {
                // ignore
            }

            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed)) {
                    return parsed
                        .map((id) => parseInt(id, 10))
                        .filter((id) => Number.isFinite(id) && id > 0);
                }
            } catch (e) {
                // ignore
            }

            return [];
        }

        function setCompletedIds(ids) {
            const uniqueIds = Array.from(new Set(ids));
            const json = JSON.stringify(uniqueIds);
            const encoded = encodeURIComponent(json);
            setCookie(COOKIE_NAME, encoded);
        }

        function markButtonCompleted(button) {
            if (!button) return;

            button.classList.add(COMPLETED_CLASS);

            const labelEl = button.querySelector('a, button, span');
            if (!labelEl) {
                return;
            }

            if (!button.dataset.labelDefault) {
                button.dataset.labelDefault = labelEl.textContent.trim();
            }

            const completedLabel =
                button.dataset.labelCompleted || 'Completed';

            labelEl.textContent = completedLabel;
            labelEl.setAttribute('aria-pressed', 'true');
        }

        function unmarkButtonCompleted(button) {
            if (!button) return;

            button.classList.remove(COMPLETED_CLASS);

            const labelEl = button.querySelector('a, button, span');
            if (!labelEl) {
                return;
            }

            const defaultLabel =
                button.dataset.labelDefault || labelEl.textContent.trim();

            labelEl.textContent = defaultLabel;
            labelEl.setAttribute('aria-pressed', 'false');
        }

        function markListingItemsCompleted(postId) {
            const items = document.querySelectorAll('.post-' + postId);
            items.forEach((el) => {
                el.classList.add(COMPLETED_CLASS);
            });
        }

        function unmarkListingItemsCompleted(postId) {
            const items = document.querySelectorAll('.post-' + postId);
            items.forEach((el) => {
                el.classList.remove(COMPLETED_CLASS);
            });
        }

        function applyCompletedStateForId(postId) {
            if (!postId) return;

            const button = document.querySelector(
                BUTTON_SELECTOR + `[data-post-id="${postId}"]`
            );
            if (button) {
                markButtonCompleted(button);
            }

            markListingItemsCompleted(postId);
        }

        function removeCompletedStateForId(postId) {
            if (!postId) return;

            const button = document.querySelector(
                BUTTON_SELECTOR + `[data-post-id="${postId}"]`
            );
            if (button) {
                unmarkButtonCompleted(button);
            }

            unmarkListingItemsCompleted(postId);
        }

        const completedIds = getCompletedIds();
        completedIds.forEach((id) => applyCompletedStateForId(id));

        const buttonWrapper = document.querySelector(BUTTON_SELECTOR);
        if (!buttonWrapper) {
            return;
        }

        const childId = parseInt(buttonWrapper.dataset.postId || '', 10);
        if (!childId) {
            return;
        }

        buttonWrapper.addEventListener('click', function (event) {
            event.preventDefault();

            let ids = getCompletedIds();
            const isCompleted = ids.includes(childId);

            if (isCompleted) {
                ids = ids.filter((id) => id !== childId);
                setCompletedIds(ids);
                removeCompletedStateForId(childId);
            } else {
                ids.push(childId);
                setCompletedIds(ids);
                applyCompletedStateForId(childId);
            }
        });
    });
})();

// Open Details Block when Post Active
(function () {
    document.addEventListener('DOMContentLoaded', () => {
        if (!window.parentDetailsData || parentDetailsData.parentId == null) {
            return;
        }

        const parentId = Number.parseInt(parentDetailsData.parentId, 10);

        if (!Number.isFinite(parentId) || parentId <= 0) {
            return;
        }

        const selector = `.wp-block-details.post-${parentId}`;
        const detailsEl = document.querySelector(selector);

        if (!detailsEl) {
            return;
        }

        if (detailsEl instanceof HTMLDetailsElement) {
            detailsEl.open = true;
        } else if ('open' in detailsEl) {
            detailsEl.open = true;
        } else {
            detailsEl.setAttribute('open', 'open');
        }
    });
})();

// Set .is-current to details block when parent-post is active
(function () {
    document.addEventListener('DOMContentLoaded', () => {
        if (!window.parentDetailsData || parentDetailsData.currentId == null) {
            return;
        }

        const postId = parseInt(parentDetailsData.currentId, 10);

        if (!Number.isFinite(postId) || postId <= 0) {
            return;
        }

        const matches = document.querySelectorAll(
            `.wp-block-details.post-${postId}`
        );

        matches.forEach((detailsEl) => {
            detailsEl.classList.add('is-current');

            if ('open' in detailsEl) {
                detailsEl.open = true;
            } else {
                detailsEl.setAttribute('open', 'open');
            }
        });
    });
})();